import { PERMISSIONS } from "../../constants";
import CityCreate from "./CityCreate";
import CityEdit from "./CityEdit";
import CityList from "./CityList";

export default {
  list: CityList,
  edit: CityEdit,
  create: CityCreate,
  name: 'cities',
  permissions: [PERMISSIONS.CITY]
};
